import { styled, Typography, Box, IconButton } from '@mui/material'

export const MonthButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[800],
  borderRadius: '6px',
  boxShadow: '0px 1.85px 3.15px 0px #00000014 !important',
  '&.Mui-disabled': {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  '& .MuiIconButton-root': {
    borderRadius: 0
  }
}))

export const MonthContainer = styled(Box)({
  width: '220px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto'
})

export const MonthTypography = styled(Typography)({
  width: '140px',
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: 500
})
